import '@css/main.scss'
import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Slider} from '@js/components/Slider'
import {Archive} from '@js/components/Archive'
import {Scroll} from '@js/animations/Scroll'
import {Map} from '@js/components/Map'
import {LivewirePagination} from "@js/components/livewirePagination";
import {MobileMap} from "@js/components/MobileMap";
import {Translation} from "@js/animations/Translation";
import {Accordion} from "@js/components/Accordion";
import {PostPasswordForm} from "@js/components/PostPasswordForm";

window.onload = () => {

  let select = document.querySelector('.select2')

  if (!select) {
    new Scroll()
  }

  new Header()
  new Archive()
  new Slider()
  new Map()
  new LivewirePagination()
  new MobileMap()
  new Translation()
  new Accordion()
  new PostPasswordForm()
}
